var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlanket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 432V464C448 472.75 440.75 480 432 480H128C57.25 480 0 422.75 0 352V128C0 75.125 43.125 32 96 32H352C404.875 32 448 75.125 448 128C448 128 447.875 309.5 447.625 312.375C443.375 354 405.125 384 363.25 384H128C110.25 384 96 369.75 96 352S110.25 320 128 320H368C376.75 320 384 312.75 384 304S376.75 288 368 288H128C92.75 288 64 316.75 64 352S92.75 416 128 416H432C440.75 416 448 423.25 448 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlanket);
export default __webpack_public_path__ + "static/media/blanket.782be499d70329d083a541101135323e.svg";
export { ForwardRef as ReactComponent };